import type { MealStatus } from '@/features/meal/domain/enums/MealStatus'
import type { RegionMiniEntity } from '@/features/region/domain/entities/RegionMiniEntity'
import type { BranchMiniEntity } from '@/features/branch/domain/entities/BranchMiniEntity'
import type { UserMiniEntity } from '@/features/user/domain/entities/UserMiniEntity'

export class LiveMealFilterEntity {
  regions?: RegionMiniEntity[]
  statuses?: Array<MealStatus>
  fetchAll?: boolean
  fromDate?: string
  toDate?: string
  cursor?: string
  limit?: number
  branch?: BranchMiniEntity
  user?: UserMiniEntity
  mealId?: string
  referenceCode?: string
  companySearchWord?: string
  trackingPanelUser?: { trackingPanelUserId: string; trackingPanelUserDisplayName: string }
}
